// extracted by mini-css-extract-plugin
export default {"container":"styles_container__XkbH+","content":"styles_content__2Mjh-","boxInput":"styles_boxInput__jYiZe"};